<template>
  <div class="home-services-page">
    <!-- Carousel Hero Section -->
    <section class="banner__two slider-two position-relative">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" data-parallax='{"x": 100}' style="background-image: url('/shapes/shape-06.png')"></div>
      </div>
      <div class="image-layer position-absolute" style="background-image: url('/resource/page-title-bg.jpg')"></div>
      <div class="banner__data__two position-relative">
        <div class="banner-carousel owl-theme owl-carousel owl-dots-none">
          <div class="slide-item position-relative">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="content-box position-relative">
                    <div class="sub__title">
                      <h4 class="position-relative">
                        <span class="slider-text-anim two">Technology Services</span>
                      </h4>
                    </div>
                    <h2 class="position-relative">
                      <span class="slider-text-anim">Comprehensive </span><br />
                      <span class="slider-text-anim title__last">Technology <span>Solutions</span></span>
                    </h2>
                    <p>From custom software development to cloud infrastructure, we provide end-to-end technology services that drive innovation and business growth.</p>
                    <div class="btn-box">
                      <router-link to="/home-contact" class="theme-btn theme-btn-one">
                        <i class="icon-02"></i> Get Started
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-item position-relative">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="content-box position-relative">
                    <div class="sub__title">
                      <h4 class="position-relative">
                        <span class="slider-text-anim two">Custom Development</span>
                      </h4>
                    </div>
                    <h2 class="position-relative">
                      <span class="slider-text-anim title__last">Tailored <span>Solutions</span> </span>
                    </h2>
                    <p>We build custom software solutions tailored to your specific business needs, from web applications to enterprise systems.</p>
                    <div class="btn-box">
                      <router-link to="/home-contact" class="theme-btn theme-btn-one">
                        <i class="icon-02"></i> Learn More
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-item position-relative">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="content-box position-relative">
                    <div class="sub__title">
                      <h4 class="position-relative">
                        <span class="slider-text-anim two">AI & Machine Learning</span>
                      </h4>
                    </div>
                    <h2 class="position-relative">
                      <span class="slider-text-anim title__last">Intelligent <span>Automation</span></span>
                    </h2>
                    <p>Harness the power of artificial intelligence and machine learning to automate processes and gain valuable insights from your data.</p>
                    <div class="btn-box">
                      <router-link to="/home-contact" class="theme-btn theme-btn-one">
                        <i class="icon-02"></i> Explore AI
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Services Overview Section -->
    <section class="services-overview position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-header text-center">
              <div class="section-tag">
                <h4>Our Services</h4>
              </div>
              <h2>Comprehensive Technology Solutions</h2>
              <p>We offer a wide range of technology services designed to help your business thrive in the digital age.</p>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-4 col-md-6" v-for="(service, index) in services" :key="index">
            <div class="service-card">
              <div class="service-icon">
                <i :class="service.icon"></i>
              </div>
              <div class="service-content">
                <h3>{{ service.title }}</h3>
                <p>{{ service.description }}</p>
                <ul class="service-features">
                  <li v-for="(feature, featureIndex) in service.features" :key="featureIndex">
                    <i class="fas fa-check"></i> {{ feature }}
                  </li>
                </ul>
                <router-link :to="service.link" class="service-btn">
                  Learn More <i class="fas fa-arrow-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Service Categories Section -->
    <section class="service-categories position-relative see__pad">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-header text-center">
              <div class="section-tag">
                <h4>Service Categories</h4>
              </div>
              <h2>Explore Our Service Categories</h2>
              <p>Choose from our specialized service categories to find the perfect solution for your needs.</p>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-3 col-md-6" v-for="(category, index) in serviceCategories" :key="index">
            <div class="category-card">
              <div class="category-image">
                <img :src="category.image" :alt="category.title">
                <div class="category-overlay">
                  <div class="category-content">
                    <h3>{{ category.title }}</h3>
                    <p>{{ category.description }}</p>
                    <router-link :to="category.link" class="category-btn">
                      Explore <i class="fas fa-arrow-right"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Choose Our Services Section -->
    <section class="why-choose-services position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="why-choose-content">
              <div class="section-tag">
                <h4>Why Choose Us</h4>
              </div>
              <h2>Why Choose Our Services?</h2>
              <p>We deliver exceptional results through our commitment to quality, innovation, and customer satisfaction.</p>
              
              <div class="features-list">
                <div class="feature-item" v-for="(feature, index) in whyChooseFeatures" :key="index">
                  <div class="feature-icon">
                    <i :class="feature.icon"></i>
                  </div>
                  <div class="feature-content">
                    <h4>{{ feature.title }}</h4>
                    <p>{{ feature.description }}</p>
                  </div>
                </div>
              </div>
              
              <div class="btn-box">
                <router-link to="/home-contact" class="theme-btn theme-btn-one">
                  <i class="icon-02"></i> Get Started Today
                </router-link>
              </div>
            </div>
          </div>
          
          <div class="col-lg-6">
            <div class="why-choose-image">
              <img src="/resource/about-us.png" alt="Why Choose Our Services">
              <div class="stats-overlay">
                <div class="stat-item">
                  <h3>500+</h3>
                  <p>Projects Completed</p>
                </div>
                <div class="stat-item">
                  <h3>50+</h3>
                  <p>Happy Clients</p>
                </div>
                <div class="stat-item">
                  <h3>10+</h3>
                  <p>Years Experience</p>
                </div>
                <div class="stat-item">
                  <h3>24/7</h3>
                  <p>Support Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action Section -->
    <section class="services-cta position-relative see__pad">
      <div class="cta-bg" style="background-image: url('/resource/portfolio-bg.jpg')"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="cta-content text-center">
              <h2>Ready to Transform Your Business?</h2>
              <p>Let's discuss how our services can help you achieve your goals and drive growth.</p>
              <div class="btn-box">
                <router-link to="/home-contact" class="theme-btn theme-btn-one">
                  <i class="icon-02"></i> Start Your Project
                </router-link>
                <router-link to="/home-about" class="theme-btn outline-btn">
                  <i class="icon-02"></i> Learn More About Us
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { WOW } from 'wowjs'

export default {
  name: 'HomeServicesPage',
  setup() {
    const services = ref([
      {
        icon: 'fas fa-code',
        title: 'Custom Software Development',
        description: 'Tailored software solutions built to meet your specific business requirements.',
        features: [
          'Web Applications',
          'Mobile Apps',
          'Desktop Software',
          'API Development'
        ],
        link: '/home-contact'
      },
      {
        icon: 'fas fa-cloud',
        title: 'Cloud Solutions',
        description: 'Scalable cloud infrastructure and migration services for modern businesses.',
        features: [
          'Cloud Migration',
          'Infrastructure Setup',
          'DevOps Services',
          'Cloud Security'
        ],
        link: '/home-contact'
      },
      {
        icon: 'fas fa-brain',
        title: 'AI & Machine Learning',
        description: 'Intelligent solutions powered by artificial intelligence and machine learning.',
        features: [
          'Predictive Analytics',
          'Natural Language Processing',
          'Computer Vision',
          'Automation Solutions'
        ],
        link: '/home-contact'
      },
      {
        icon: 'fas fa-shield-alt',
        title: 'Cybersecurity',
        description: 'Comprehensive security solutions to protect your digital assets.',
        features: [
          'Security Audits',
          'Penetration Testing',
          'Security Monitoring',
          'Compliance Management'
        ],
        link: '/home-contact'
      },
      {
        icon: 'fas fa-mobile-alt',
        title: 'Mobile Development',
        description: 'Native and cross-platform mobile applications for iOS and Android.',
        features: [
          'iOS Development',
          'Android Development',
          'React Native',
          'Flutter Apps'
        ],
        link: '/home-contact'
      },
      {
        icon: 'fas fa-chart-line',
        title: 'Data Analytics',
        description: 'Transform your data into actionable insights and business intelligence.',
        features: [
          'Data Visualization',
          'Business Intelligence',
          'Predictive Modeling',
          'Data Warehousing'
        ],
        link: '/home-contact'
      }
    ])

    const serviceCategories = ref([
      {
        title: 'Web Development',
        description: 'Modern web applications and websites',
        image: '/resource/portfolio-01.jpg',
        link: '/home-contact'
      },
      {
        title: 'Mobile Apps',
        description: 'iOS and Android mobile applications',
        image: '/resource/portfolio-02.jpg',
        link: '/home-contact'
      },
      {
        title: 'AI Solutions',
        description: 'Artificial intelligence and automation',
        image: '/resource/portfolio-03.jpg',
        link: '/home-contact'
      },
      {
        title: 'Cloud Services',
        description: 'Cloud infrastructure and migration',
        image: '/resource/portfolio-04.jpg',
        link: '/home-contact'
      }
    ])

    const whyChooseFeatures = ref([
      {
        icon: 'fas fa-award',
        title: 'Proven Expertise',
        description: 'Over 10 years of experience delivering successful projects across various industries.'
      },
      {
        icon: 'fas fa-clock',
        title: 'Fast Delivery',
        description: 'We deliver projects on time without compromising on quality or functionality.'
      },
      {
        icon: 'fas fa-users',
        title: 'Dedicated Team',
        description: 'Our experienced team is committed to understanding and meeting your unique needs.'
      },
      {
        icon: 'fas fa-headset',
        title: '24/7 Support',
        description: 'Round-the-clock support to ensure your systems run smoothly at all times.'
      }
    ])

    onMounted(() => {
      // Initialize WOW.js
      new WOW({
        mobile: false,
        live: false
      }).init()

      // Initialize Owl Carousel
      if (window.$ && window.$.fn.owlCarousel) {
        window.$('.banner-carousel').owlCarousel({
          loop: true,
          margin: 0,
          nav: false,
          dots: false,
          autoplay: true,
          autoplayTimeout: 6000,
          autoplayHoverPause: true,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          items: 1,
          smartSpeed: 1000
        })
      }
    })

    return {
      services,
      serviceCategories,
      whyChooseFeatures
    }
  }
}
</script>

<style scoped>
/* Home Services Page Styles */
.home-services-page {
  background: #f8f9fa;
}

/* Banner Section */
.banner__two {
  padding: 120px 0 100px;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  position: relative;
  overflow: hidden;
}

.banner__two .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.banner__two .pattern-1 {
  top: 20%;
  right: 10%;
  width: 200px;
  height: 200px;
  opacity: 0.1;
}

.banner__two .image-layer {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.1;
}

.banner__two .content-box {
  z-index: 2;
}

.banner__two .sub__title h4 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.banner__two h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  line-height: 1.2;
}

.banner__two p {
  font-size: 18px;
  color: #ccc;
  margin-bottom: 30px;
  line-height: 1.6;
}

.theme-btn {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  padding: 15px 35px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.theme-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(220, 53, 69, 0.3);
  color: white;
  text-decoration: none;
}

.outline-btn {
  background: transparent;
  border: 2px solid #dc3545;
  color: #dc3545;
}

.outline-btn:hover {
  background: #dc3545;
  color: white;
}

/* Services Overview Section */
.services-overview {
  padding: 80px 0;
  background: #fff;
  position: relative;
}

.services-overview .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.services-overview .pattern-1 {
  top: 10%;
  left: 5%;
  width: 100px;
  height: 100px;
  opacity: 0.05;
}

.services-overview .pattern-2 {
  bottom: 10%;
  right: 5%;
  width: 120px;
  height: 120px;
  opacity: 0.05;
}

.section-header {
  margin-bottom: 60px;
}

.section-tag h4 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #dc3545;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.section-header h2 {
  font-size: 36px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.section-header p {
  font-size: 18px;
  color: #6c757d;
  max-width: 600px;
  margin: 0 auto;
}

.service-card {
  background: #fff;
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
  margin-bottom: 30px;
  height: 100%;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.service-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}

.service-icon i {
  font-size: 32px;
  color: white;
}

.service-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.service-content p {
  font-size: 16px;
  color: #6c757d;
  margin-bottom: 20px;
  line-height: 1.6;
}

.service-features {
  list-style: none;
  padding: 0;
  margin-bottom: 25px;
}

.service-features li {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.service-features li i {
  color: #28a745;
  font-size: 12px;
}

.service-btn {
  color: #dc3545;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.service-btn:hover {
  color: #c82333;
  text-decoration: none;
}

/* Service Categories Section */
.service-categories {
  padding: 80px 0;
  background: #f8f9fa;
}

.category-card {
  margin-bottom: 30px;
}

.category-image {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  height: 300px;
}

.category-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.category-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.9), rgba(200, 35, 51, 0.9));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.category-card:hover .category-overlay {
  opacity: 1;
}

.category-card:hover .category-image img {
  transform: scale(1.1);
}

.category-content {
  text-align: center;
  color: white;
  padding: 20px;
}

.category-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.category-content p {
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.category-btn {
  color: white;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 2px solid white;
  border-radius: 25px;
  transition: all 0.3s ease;
}

.category-btn:hover {
  background: white;
  color: #dc3545;
  text-decoration: none;
}

/* Why Choose Services Section */
.why-choose-services {
  padding: 80px 0;
  background: #fff;
  position: relative;
}

.why-choose-services .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.why-choose-services .pattern-3 {
  top: 20%;
  right: 10%;
  width: 150px;
  height: 150px;
  opacity: 0.05;
}

.why-choose-services .pattern-4 {
  bottom: 20%;
  left: 10%;
  width: 100px;
  height: 100px;
  opacity: 0.05;
}

.why-choose-content h2 {
  font-size: 36px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.why-choose-content p {
  font-size: 18px;
  color: #6c757d;
  margin-bottom: 40px;
  line-height: 1.6;
}

.features-list {
  margin-bottom: 40px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-icon i {
  font-size: 24px;
  color: white;
}

.feature-content h4 {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.feature-content p {
  font-size: 16px;
  color: #6c757d;
  line-height: 1.6;
  margin: 0;
}

.why-choose-image {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
}

.why-choose-image img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.stats-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 30px 20px 20px;
  display: flex;
  justify-content: space-around;
}

.stat-item {
  text-align: center;
  color: white;
}

.stat-item h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
  font-family: 'Archivo', sans-serif;
}

.stat-item p {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

/* CTA Section */
.services-cta {
  padding: 80px 0;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  position: relative;
  overflow: hidden;
}

.services-cta .cta-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.1;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-content h2 {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-content p {
  font-size: 18px;
  color: #ccc;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.btn-box {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  flex-wrap: wrap;
}

/* Responsive Design */
@media (max-width: 991px) {
  .why-choose-image {
    margin-top: 40px;
  }
  
  .stats-overlay {
    flex-direction: column;
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .banner__two {
    padding: 100px 0 80px;
  }
  
  .banner__two h2 {
    font-size: 36px;
  }
  
  .services-overview,
  .service-categories,
  .why-choose-services,
  .services-cta {
    padding: 60px 0;
  }
  
  .section-header h2 {
    font-size: 28px;
  }
  
  .service-card {
    padding: 30px 20px;
  }
  
  .why-choose-content h2 {
    font-size: 28px;
  }
  
  .cta-content h2 {
    font-size: 28px;
  }
  
  .btn-box {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .banner__two h2 {
    font-size: 28px;
  }
  
  .banner__two p {
    font-size: 16px;
  }
  
  .service-card {
    padding: 25px 15px;
  }
  
  .service-icon {
    width: 60px;
    height: 60px;
  }
  
  .service-icon i {
    font-size: 24px;
  }
  
  .feature-item {
    flex-direction: column;
    text-align: center;
  }
}
</style>
